import { useMemo } from 'react'

const SLOT_LABELS = { breakfast: 'Breakfast', lunch: 'Lunch', dinner: 'Dinner', snack: 'Snack' }
const SLOT_ORDER  = ['breakfast', 'lunch', 'dinner', 'snack']

export function MealPlanPanel({ data }) {
  const { mealSlots = [] } = data

  const today    = new Date().toISOString().split('T')[0]
  const tomorrow = new Date(Date.now() + 86400000).toISOString().split('T')[0]

  const byDate = useMemo(() => {
    const grouped = {}
    for (const slot of mealSlots) {
      if (!grouped[slot.date]) grouped[slot.date] = {}
      grouped[slot.date][slot.slot_name] = slot
    }
    return grouped
  }, [mealSlots])

  const todaySlots    = byDate[today]    ?? {}
  const tomorrowSlots = byDate[tomorrow] ?? {}

  const MealCard = ({ slot, highlight }) => {
    const name = slot?.recipe?.title ?? slot?.custom_name ?? null
    return (
      <div className={`rounded-xl px-3 py-2 ${highlight ? 'bg-white/10' : 'bg-white/6'}`}>
        <p className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-0.5">
          {SLOT_LABELS[slot?.slot_name ?? ''] ?? ''}
        </p>
        {name ? (
          <>
            <p className={`text-white font-semibold leading-snug ${highlight ? 'text-base sm:text-xl' : 'text-sm sm:text-base'}`}>{name}</p>
            {slot?.recipe?.cook_time_minutes && (
              <p className="text-gray-500 text-xs mt-0.5">{slot.recipe.cook_time_minutes} min</p>
            )}
          </>
        ) : (
          <p className={`text-gray-600 italic ${highlight ? 'text-base sm:text-lg' : 'text-xs sm:text-sm'}`}>Not planned</p>
        )}
      </div>
    )
  }

  return (
    <div className="flex flex-col h-full px-4 sm:px-8 py-4 sm:py-6 panel-animate-in min-h-0">
      <p className="text-gray-500 text-xs sm:text-sm font-semibold uppercase tracking-widest mb-3">On the Menu</p>

      <div className="flex-1 grid grid-cols-2 gap-4 sm:gap-6 min-h-0 overflow-hidden">
        <div className="flex flex-col gap-2 overflow-y-auto min-h-0 scrollbar-hide">
          <h3 className="text-white text-base sm:text-xl font-bold flex-shrink-0">Today</h3>
          {SLOT_ORDER.map((s) => (
            <MealCard key={s} slot={todaySlots[s] ? { ...todaySlots[s], slot_name: s } : { slot_name: s }} highlight={s === 'dinner'} />
          ))}
        </div>

        <div className="flex flex-col gap-2 overflow-y-auto min-h-0 scrollbar-hide">
          <h3 className="text-gray-400 text-base sm:text-xl font-bold flex-shrink-0">Tomorrow</h3>
          {SLOT_ORDER.map((s) => (
            <MealCard key={s} slot={tomorrowSlots[s] ? { ...tomorrowSlots[s], slot_name: s } : { slot_name: s }} highlight={false} />
          ))}
        </div>
      </div>
    </div>
  )
}
